import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/CorrugatedSheetCalculator/corrugatedSheetCalculator.container"
    ).then((module) => ({ default: module.CorrugatedSheetCalculator }))
);
